import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink-950 py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-13" data-mp="1bmd7383s4e5l">
      <div className="mx-auto max-w-3xl px-5" data-id="element-14" data-mp="1gketa1wi4tla">
        <h2 id="faq-title" className="font-display text-3xl font-black uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-15" data-mp="2496a5x4n5pir">
          Preguntas frecuentes
        </h2>

        <ul className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-16" data-mp="1ujmpqn1a5nls">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} data-id="element-17" data-mp="1zg4uhmwm1ly4" data-mpi={i}>
                <h3 data-id="element-18" data-mp="2n7ipy1q25xnb">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left outline-none transition-colors duration-150 ease-smooth hover:text-flame focus-visible:text-flame" data-id="element-19" data-mp="2n7a9jzuq8a7d">
                    <span className="font-display text-lg font-bold text-white" data-id="element-20" data-mp="1en6m07808dmy">{faq.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-flame transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-21" data-mp="19safy35xnpqu" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-22" data-mp="1skv457aot6ob">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-23" data-mp="1sj1y9u7weqhd">
                      <p className="pb-5 pr-10 text-[0.95rem] leading-relaxed text-white/60" data-id="element-24" data-mp="23a0xunqzvi97">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}